import * as types from '../constants'

import API_PRODUCTS from '@api/products'

export const updateHighlight = payload => ({
  type: types.UPDATE_HIGHLIGHT_PRODUCT,
  payload,
})

export const updateManifestVideo = payload => ({
  type: types.UPDATE_MANIFEST_VIDEO,
  payload,
})

export const getHomeProducts = (region) => dispatch => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getHomeProducts(region).then((response) => {
      if (response.success) {
        dispatch(updateHighlight(response))
        const idEstado = response.IdEstado || region
        if (idEstado) {
          localStorage.setItem('storedRegion', idEstado)
        }
        API_PRODUCTS.getManifestVideo(region).then(response => {
          dispatch(updateManifestVideo(response.manifesto))
        })
        resolve(response)
      } else {
        reject('error')
      }
    })
      .catch(error => {
        reject(error)
      })
  })
}
export const getAllProducts = ({ region, city = null, neighborhood = null }) => dispatch => {

  return new Promise((resolve, reject) => {
    API_PRODUCTS.getAllProducts({ region, city, neighborhood }).then((response) => {
      if (response.success) {
        const productsOrdered = [...response.Imoveis]
          .sort((a, b) => a.OrdemHome - b.OrdemHome)
        dispatch(updateHighlight({ ...response, Imoveis: productsOrdered }))
        const idEstado = response.IdEstado || region
        if (idEstado) {
          localStorage.setItem('storedRegion', idEstado)
        }
        resolve(response)
      } else {
        reject('error')
      }
    })
      .catch(error => {
        reject(error)
      })
  })
}

export const updatePreviousProduct = payload => ({
  type: types.UPDATE_PREVIOUS_PRODUCT,
  payload,
})
export const updateProductBySlug = payload => ({
  type: types.UPDATE_PRODUCT,
  payload,
})
export const updateLPContent = payload => ({
  type: types.UPDATE_LANDINGPAGE,
  payload,
})
export const updateCurrentTour = payload => ({
  type: types.UPDATE_CURRENT_TOUR,
  payload,
})
export const updateCurrentGallery = payload => ({
  type: types.UPDATE_CURRENT_GALLERY,
  payload,
})

export const getProductBySlug = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getProductBySlug(payload).then((response) => {
      dispatch(updateProductBySlug(response))
      resolve(response)
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const getProductById = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getProductById(payload).then((response) => {
      dispatch(updateProductBySlug(response))
      resolve(response)
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const getLPContent = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getCustomLpContent(payload).then((response) => {
      dispatch(updateLPContent(response))
      resolve(response)
    })
      .catch((error) => {
        reject(error)
      })
  })
}


export const updateHouseVivazContent = payload => ({
  type: types.UPDATE_HOUSE_VIVAZ,
  payload,
})


export const getHouseVivazContent = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getLPHouseVivaz(payload).then((response) => {
      dispatch(updateHouseVivazContent(response))
      resolve(response)
    })
      .catch((error) => {
        reject(error)
      })
  })
}

export const updateCustomLpContent = payload => ({
  type: types.UPDATE_CUSTOM_LP,
  payload,
})

export const getCustomLpContent = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getCustomLpContent(payload).then((response) => {

      dispatch(updateCustomLpContent(response.Lp))
      resolve()
    }).catch((error) => {
      reject(error)
    })

  })
}
export const updateLocationById = payload => ({
  type: types.UPDATE_LOCATION_PRODUCT,
  payload,
})

export const getLocationById = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getLocationById(payload).then((response) => {
      dispatch(updateLocationById(response))
      resolve()
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const updateRecreationById = payload => ({
  type: types.UPDATE_RECREATION_PRODUCT,
  payload,
})

export const getRecreationById = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getRecreationById(payload).then((response) => {
      dispatch(updateRecreationById(response))
      resolve()
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const updatePlantById = payload => ({
  type: types.UPDATE_PLANT_PRODUCT,
  payload,
})

export const getPlantById = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getPlantById(payload).then((response) => {
      dispatch(updatePlantById(response))
      resolve()
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const updateFacilitiesById = payload => ({
  type: types.UPDATE_FACILITIES_PRODUCT,
  payload,
})

export const getFacilitiesById = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getFacilitiesById(payload).then((response) => {
      dispatch(updateFacilitiesById(response))
      resolve()
    }).catch((error) => {
      reject(error)
    })

  })
}


export const updateVideoByIdState = payload => ({
  type: types.UPDATE_VIDEO_BY_ID_STATE,
  payload,
})

export const getVideoByIdState = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_PRODUCTS.getvideoByIdState(payload).then((response) => {
      if (response.video) {
        const url = new URL(response.video.UrlVideo)

        response.video.codeVideo = url.searchParams.get('v')
      }

      dispatch(updateVideoByIdState(response))
      resolve()
    }).catch((error) => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/products/actions.js